export enum FileType {
  mst = 'mst',
  csv = 'csv',
  fcderrorscsv = 'fcderrorscsv',
  geojsonlinear = 'geojsonlinear',
  geojsonpoint = 'geojsonpoint',
  shapefile = 'shapefile',
  validations = 'validations',
  vildchanges = 'vildchanges',
  KPI = 'KPI',
  VILD = 'VILD',
  historicshapes = 'historicshapes'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/filetype.ts